import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "@firebase/database";// Add this import

import {
  Link, Route, Routes, useParams, useNavigate, useLocation, redirect,
} from "react-router-dom";
import RadioButton from "./MapOfAvailableClasses/AvailableClasses";
import { firebase } from "../Firebase/config";

import NavBar from "./Navbar";
import {
  getCountFromServer,
  onSnapshot,
  updateDoc,
  orderBy,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  arrayUnion,
} from "@firebase/firestore";
import axios from "axios";
import "./availableclasses.css";

const Availableclassesatyourschool = (props) => {
  const { route, navigation } = props;

    const [selectedclass, setSelectedclass] = useState("");
  const [data, setData] = useState([]);
  const [idofclass, setIdofclass] = useState();
  const [coursesenrolled, setCoursesenrolled] = useState([]);
  const [isselected, setIsselected] = useState();
  const [showspinner, setShowspinner] = useState(false);
  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [text8, setText8] = useState("");
  const [text9, setText9] = useState("");
  const [text10, setText10] = useState("");
  const [text11, setText11] = useState("");
  const [text12, setText12] = useState("");
  const [text13, setText13] = useState("");
  const [text14, setText14] = useState("");
  const [text15, setText15] = useState("");
  const [text16, setText16] = useState("");
  const [text17, setText17] = useState("");
  const [text18, setText18] = useState("");
  const [text19, setText19] = useState("");

  const [id, setId] = useState();
  const [userState, setUserState] = useState({});
  const [pnumber, setPnumber] = useState("");
  const [yourotp, setYourotp] = useState("");
  const [verifyphone, setVerifyphone] = useState("");
  const [classid3, setClassid3] = useState("");
  const [languagecode2, setLanguagecode2] = useState("en");
  const [language2, setLanguage2] = useState("English");
  const [parentlanguagecode2, setParentlanguagecode2] = useState("en");
  const [classid, setClassid] = useState("");
  const [role, setRole] = useState("");

  const [phonenumberbefore, setPhonenumberbefore] = useState("");
  const [phonenumber, setPhonenumber] = useState();
  const [tempeng, setTempeng] = useState();
  const [editmyphonenumber, setEditphonenumber] = useState();
  const [otpfromtext, setOtpfromtext] = useState();
  const [classnamee, setClassnamee] = useState();
  const [student, setStudent] = useState();
  const [filteredstates, setFilteredstates] = useState([]);
  const [searchingstate, setSearchingstate] = useState(false);
  const [pickindex, setPickindex] = useState(0);
  const [num, setNum] = useState();
  const [isfocused2, setIsfocused2] = useState();
  const [teacherrrr, setTeacherrrr] = useState();

  const [donotshow, setDonotshow] = useState();

  const [temparray, setTemparray] = useState();
  const [activeid, setActiveid] = useState("123");

    const [id2, setId2] = useState();
    // Add state variables for the other passed values
    const [school, setSchool] = useState();
    const [town, setTown] = useState();
    const [state, setState] = useState();
    const [role2, setRole2] = useState();
    const [firstname, setFirstname] = useState();
    const [lastname, setLastname] = useState();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();

    const [activestudentlist, setActivestudentlist] = useState();
  
    const [activestudentlist2, setActivestudentlist2] = useState([]);
  
    const [activeperiod, setActiveperiod] = useState("");
    const [gclassroomid, setGclassroomid] = useState("");
    const [gclassroomname, setGclassroomname] = useState("");

    const [parentlanguage2, setParentlanguage2] = useState("");
const [classlist, setClasslist] = useState([]);
const [teacherlist, setTeacherlist] = useState([]);
const [isverified, setIsverified] = useState(true);
const [currentclass, setCurrentclass] = useState("");
const [googleclassroomid, setGoogleclassroomid] = useState("");
const [consequenceid, setConsequenceid] = useState("");
const [currentlocation, setCurrentlocation] = useState("");
const [otp, setOtp] = useState("");
  


  // Add useLocation hook to get state from React Router navigation
    const [personaldata, setPersonaldata] = useState();
  
     const location = useLocation();
  
    useEffect(() => {
      if (typeof location.state !== "undefined" && location.state !== null) {
        console.log("Setting state from location.state:", location.state.personaldata);
        setPersonaldata(location.state.personaldata);
      }
    }, []);
useEffect(() => {
  if (typeof personaldata !== "undefined" && personaldata !== null) {
    setId2(personaldata.id);
    setRole2(personaldata.role);
    setFirstname(personaldata.localfirstname || personaldata.firstname);
    setLastname(personaldata.locallastname || personaldata.lastname);
    setEmail(personaldata.email);
    setPhone(personaldata.phonenumber);
    setSchool(personaldata.school);
    setTown(personaldata.town);
    setState(personaldata.state);
    setLanguage2(personaldata.language);
    setLanguagecode2(personaldata.languagecode);
    setParentlanguage2(personaldata.parentlanguage);
    setParentlanguagecode2(personaldata.parentlanguagecode);
    setClasslist(personaldata.classlist || []);
    setTeacherlist(personaldata.teacherlist || []);
    setIsverified(personaldata.isverified);
    setCurrentclass(personaldata.currentclass);
    setGoogleclassroomid(personaldata.googleclassroomid);
    setConsequenceid(personaldata.consequenceid);
    setCurrentlocation(personaldata.currentlocation);
    setOtp(personaldata.otp);
    // Add more setXxx(personaldata.xxx) as needed for other fields you use
  }
}, [personaldata]);
  
  //Example to send with dp
  
      const navigate = useNavigate();
      // navigate(newidforstudent1, { state: { personaldata } });
  

  // Immediately set user state from localStorage if location.state is not present





  // Modify the useEffect that calls getclasses to handle more scenarios
  useEffect(() => {
    // First check if id exists from any source
    const studentId = id || userState.id2;

    if (studentId) {
      getclasses(studentId);
    } else {
      console.error("No valid student ID found");
    }
  }, [id, userState.id2]);

  // Update the getclasses function to accept the ID as a parameter
  async function getclasses(studentId) {
    try {
      if (!studentId) {
        console.error("No valid student ID provided to getclasses()");
        return;
      }

      const f = query(
        collection(firebase, "classesbeingtaught"),
        where("students", "array-contains", studentId)
      );

      const querySnapshot = await getDocs(f);

      if (querySnapshot.empty) {
        alert("No classes found for student ID:", studentId);
        return;
      }

      const array2 = [];
     

      querySnapshot.forEach((doc) => {
        let user = {
          key: doc.data().id,
          classname: doc.data().classname,
          period: doc.data().period,
          students: doc.data().students,
          googleclassroomid: doc.data().googleclassroomid ? doc.data().googleclassroomid : "",
          googleclassroomname: doc.data().googleclassroomname ? doc.data().googleclassroomname : "",
        };
        array2.push(user);
      });

      localStorage.setItem("myclasses", JSON.stringify(array2));
      setTemparray(array2);

      // Add this to update userState with the classlist if needed
      if (array2.length > 0 && !userState.classlist) {
        setUserState(prev => ({
          ...prev,
          classlist: array2.map(c => c.key)
        }));
      }
    } catch (error) {
      console.error("Error fetching classes:", error.message || error);
      // Initialize with an empty array instead of showing an error
    }
  }

  useEffect(() => {
    setDonotshow(true);
  }, []);

  const db = getDatabase();
  const connectedRef = ref(db, ".info/connected");

  // Mock isFocused from react-navigation
  const isFocused = true;

  useEffect(() => {
    if (typeof pnumber != "undefined") {
      setPhonenumber(pnumber);
    }
  }, [pnumber]);

  useEffect(() => {
    if (typeof pnumber != "undefined") {
      setPhonenumber(pnumber);
      getcoursesenrolledin();
    }
  }, []);

  useEffect(() => {
    console.log(pnumber, "pnumber", phonenumber, "phonenumber");
  }, [pnumber, phonenumber]);

  const onChanged = (text) => {
    setPhonenumberbefore(text.replace(/[^0-9]/g, ""));
    if (text == 1) {
      setPhonenumberbefore("");
    }
  };

  useEffect(() => {
    if (isFocused) {
      setIsfocused2(true);
    } else {
      setIsfocused2(false);
    }
  }, [isFocused]);

  useEffect(() => {
    console.log("changing class on 7", selectedclass, "selectedclass");
    if (typeof selectedclass != "undefined") {
      console.log("changing class on 8");
      setIdofclass(selectedclass.id);
      setClassnamee(selectedclass.classname);
      setTeacherrrr(selectedclass.teacherid);
    }
  }, [selectedclass]);

  useEffect(() => {
    if (typeof idofclass != "undefined" && idofclass != "") {
      console.log("YAAAAA", idofclass, "YAAAA");
    }
  }, [idofclass]);

  useEffect(() => {
    console.log("Hiiiiiiiiii", yourotp, otpfromtext, verifyphone);
    if (yourotp == otpfromtext) {
      if (
        (verifyphone == "verifyphone" && typeof classid != "undefined") ||
        (typeof classid3 != "undefined" && classid3 != "")
      ) {
        veerifyphone();
      } else {
        enrollingstudent();
      }
    } else {
      // Do nothing if codes don't match
    }
  }, [otpfromtext]);

  useEffect(() => {
    if (
      languagecode2 != "" &&
      language2 != "English" &&
      typeof language2 != "undefined"
    ) {
      console.log(" 1 Does this show up here??????? Classes studnet");

      setShowspinner(true);
      setTempeng(true);
      getStoredLanguage();
    }
  }, [languagecode2]);

  // This gets run automatically if otpfromtext matches yourotp. It then verifies the student's phone number.
  const veerifyphone = () => {
    if (language2 != "English" && typeof language2 != "undefined") {
      setShowspinner(true);

      updateDoc(doc(firebase, "users", id), {
        isverified: true,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        })
        .then(function () {
          setShowspinner(false);
          alert(text19);
          // Phone verification complete - student remains on AvailableClasses screen
          console.log(
            "Phone verification completed. Student stays on current screen."
          );
        });
    } else {
      setShowspinner(true);

      updateDoc(doc(firebase, "users", id), {
        isverified: true,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        })
        .then(function () {
          setShowspinner(false);
          alert("You are all set. You may now make a pass.");
          // Phone verification complete - student remains on AvailableClasses screen
          console.log(
            "Phone verification completed. Student stays on current screen."
          );
        });
    }
  };

  // This function gets run if the student was brought over after signup but are not yet in the class.
  const enrollingstudent = () => {
    const current = Date.now();

    if (typeof idofclass != "undefined") {
      const percents = {
        id: idofclass,
        penaltyminutes: 0,
        overunder: 0,
        level: "No Consequences For Lateness",
        totalpassesinlastsevendays: 0,
        passesallowedinweekifonpenalty: 2,
        recentpasses: 0,
        selected: false,
      };
      setShowspinner(true);

      updateDoc(doc(firebase, "users", id), {
        [idofclass]: percents,
        classlist: arrayUnion(idofclass),
        teacherlist: arrayUnion(teacherrrr),
        isverified: true,
      }).catch((error) => {
        console.log(error);
        alert(error);
      });

      updateDoc(doc(firebase, "classesbeingtaught", idofclass), {
        students: arrayUnion(id),
        languagesinthisclass: arrayUnion(languagecode2),
        languagesinthisclassparents: arrayUnion(parentlanguagecode2),
      }).catch((error) => {
        console.log(error);
        alert(error);
      });

      //force a check to see if id exists in the list of students on the teacher side

      updateDoc(doc(firebase, "users", teacherrrr), {
        teachersidecheck: arrayUnion(id),
        lastteachercheck: current,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        })

        .then(function () {
          setShowspinner(false);
          alert("You have just joined " + classnamee);
          // Student enrolled successfully - remains on AvailableClasses screen
          console.log(
            "Student enrolled in class successfully. Student stays on current screen."
          );
        });
    }
  };

  //begins process to save phonenumber
  async function savethisphonenumber() {
    console.log("This is the phonenumber", phonenumberbefore);
    setPhonenumber(phonenumberbefore);
  }

  useEffect(() => {
    if (typeof phonenumber != "undefined") {
      if (phonenumber.length == 10) {
        savethisphonenumber2();
      } else {
        if (language2 != "English" && text17 != "") {
          setEditphonenumber(true);
          alert(text17);
        } else if (language2 == "English") {
          setEditphonenumber(true);
          alert(
            phonenumber +
              phonenumber.length +
              "Your Phone Number is not accurate. You must reenter it."
          );
        }
      }
    }
  }, [phonenumber, text17]);

  // This is the "Save this number" function
  async function savethisphonenumber2() {
    //saving but not yet verified. This is to allow for a sending of an OTP by text.
    console.log(id, "id", "This is the phonenumber", phonenumber);

    // Use localStorage instead of AsyncStorage for web
    localStorage.setItem("phonenumber", phonenumber);

    setShowspinner(true);

    await updateDoc(doc(firebase, "users", id), {
      phonenumber: phonenumber,
    })
      .catch((error) => {
        console.log(error);
        alert(error);
      })

      .then(async (check) => {
        setEditphonenumber(false);

        setTimeout(() => {
          setShowspinner(false);
          setPhonenumberbefore("");
          // this is to let the teachers side to do a refresh.
          if (
            typeof teacherrrr != "undefined" &&
            typeof idofclass != "undefined" &&
            typeof classnamee != "undefined"
          ) {
            let number = Date.now();

            updateDoc(doc(firebase, "users", teacherrrr), {
              teachersidecheck: arrayUnion(id),
              lastteachercheck: number,
            }).catch((error) => {
              console.log(error);
              alert(error);
            });
          }
        }, 1000);
      });
  }

  // We'll adapt AsyncStorage to localStorage for web
  const getStoredLanguage = async () => {
    console.log("2 was getStorageLanguage run?");

    try {
      const value = localStorage.getItem("availableclasseslanguagecode2");
      if (value !== null && value == languagecode2) {
        console.log("3", languagecode2, value, "Here is another example");

        console.log(
          "4 The language HAS BEEN SET.",
          value,
          languagecode2,
          "What is happening"
        );

        getData0();
        getData1();
        getData2();
        getData3();
        getData4();
        getData5();
        getData6();
        getData7();
        getData8();
        getData9();
        getData10();
        getData11();
        getData12();
        getData13();
        getData14();
        getData15();
        getData16();
        getData17();
        getData18();
        getData19();
      } else {
        console.log("5 The language has NOT YET been set. ");

        localStorage.setItem("availableclasseslanguagecode2", languagecode2);

        getnewlanguaage0();
        getnewlanguaage1();
        getnewlanguaage2();
        getnewlanguaage3();
        getnewlanguaage4();
        getnewlanguaage5();
        getnewlanguaage6();
        getnewlanguaage7();
        getnewlanguaage8();
        getnewlanguaage9();
        getnewlanguaage10();
        getnewlanguaage11();
        getnewlanguaage12();
        getnewlanguaage13();
        getnewlanguaage14();
        getnewlanguaage15();
        getnewlanguaage16();
        getnewlanguaage17();
        getnewlanguaage18();
        getnewlanguaage19();
      }
    } catch (e) {
      console.log("SOMETHING WENT WRONG HERE!!!");
    }
  };

  // All the getData functions (converted from AsyncStorage to localStorage)
  const getData0 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext0");
      if (value !== null) {
        console.log("This is the value1", value);
        setText0(value);
      } else {
        console.log("This is the value2", value);
        getnewlanguaage0();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData1 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext1");
      if (value !== null) {
        setText1(value);
      } else {
        getnewlanguaage1();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData2 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext2");
      if (value !== null) {
        setText2(value);
      } else {
        getnewlanguaage2();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData3 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext3");
      if (value !== null) {
        setText3(value);
      } else {
        getnewlanguaage3();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData4 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext4");
      if (value !== null) {
        setText4(value);
      } else {
        getnewlanguaage4();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData5 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext5");
      if (value !== null) {
        setText5(value);
      } else {
        getnewlanguaage5();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData6 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext6");
      if (value !== null) {
        setText6(value);
      } else {
        getnewlanguaage6();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData7 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext7");
      if (value !== null) {
        setText7(value);
      } else {
        getnewlanguaage7();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData8 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext8");
      if (value !== null) {
        setText8(value);
      } else {
        getnewlanguaage8();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData9 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext9");
      if (value !== null) {
        setText9(value);
      } else {
        getnewlanguaage9();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData10 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext10");
      if (value !== null) {
        setText10(value);
      } else {
        getnewlanguaage10();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData11 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext11");
      if (value !== null) {
        setText11(value);
      } else {
        getnewlanguaage11();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData12 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext12");
      if (value !== null) {
        setText12(value);
      } else {
        getnewlanguaage12();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData13 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext13");
      if (value !== null) {
        setText13(value);
      } else {
        getnewlanguaage13();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData14 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext14");
      if (value !== null) {
        setText14(value);
      } else {
        getnewlanguaage14();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData15 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext15");
      if (value !== null) {
        setText15(value);
      } else {
        getnewlanguaage15();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData16 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext16");
      if (value !== null) {
        setText16(value);
      } else {
        getnewlanguaage16();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData17 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext17");
      if (value !== null) {
        setText17(value);
      } else {
        getnewlanguaage17();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData18 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext18");
      if (value !== null) {
        setText18(value);
      } else {
        getnewlanguaage18();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData19 = async () => {
    try {
      const value = localStorage.getItem("availableclassestext18");
      if (value !== null) {
        setText19(value);
      } else {
        getnewlanguaage19();
      }
    } catch (e) {
      // error reading value
    }
  };

  // One of the translation functions to show the pattern
  const getnewlanguaage0 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      setShowspinner(true);

      console.log("This is the language code TYYYYYYY12345666", languagecode2);

      try {
        let languageeee = languagecode2;

        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Current User",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log(
          "This is the responseBBBBB",
          languageeee,
          response.data.data.translations[0].translatedText
        );

        setText0(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext0",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage1 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Guest",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText1(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext1",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage2 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Find & Select Your Current Class",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText2(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext2",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage3 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "'OTP' can be sent by the teacher from ",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText3(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext3",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage4 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "'Passes From This Class' screen OR 'Students Enrolled' screen.",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText4(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext4",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage5 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "No Class is Selected",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText5(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext5",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage6 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "See Classes",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText6(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext6",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage7 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Class Identifier",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText7(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext7",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage8 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Request code texted from Teacher",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText8(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext8",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage9 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Enter code from Text",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText9(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext9",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage10 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "That is the correct code!",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText10(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext10",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage11 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Press Here to Enter Class",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText11(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext11",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage12 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Edit My Phone Number",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText12(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext12",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage13 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Save This Number",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText13(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext13",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage14 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "You are now awaiting an 'OTP' from your teacher",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText14(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext14",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage15 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your Phone Number is unverified. Input the Correct One Below",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText15(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext15",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage16 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Phone Number Edit",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText16(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext16",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage17 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your Phone Number is not accurate. You must reenter it.",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText17(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext17",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage18 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "Your Phone Number",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText18(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext18",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const getnewlanguaage19 = async () => {
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post(
          "https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY",
          {
            source: "en",
            format: "text",
            q: "You are all set. You may now make a pass.",
            target: `${languagecode2}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setText19(response.data.data.translations[0].translatedText);
        localStorage.setItem(
          "availableclassestext19",
          response.data.data.translations[0].translatedText
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  // Similar implementations for other translation functions
  // ...existing code...

  useEffect(() => {
    setIsselected(false);
  }, []);

  const timenow = Date.now() - 1000;

  useEffect(
    () =>
      onSnapshot(doc(firebase, "users", id), (doc) => {
        console.log("Insiidee onSnapshoot21", id);

        const newvalue = doc.data().timeofupdate;

        if (newvalue > timenow) {
          alert(
            "Check your texts for an OTP (One Time Pass Code) from " +
              data.find((v) => v.id === doc.data().updateclass).classname
          );

          setSelectedclass(data.find((v) => v.id === doc.data().updateclass));

          setNum(
            data.findIndex((object) => object.id === doc.data().updateclass)
          );
        }
      }),
    [data]
  );

  useEffect(() => {
    if (student) {
      textsearchedstates(student);
      console.log("this state has been input", student);
    } else {
      setFilteredstates(data);
    }
  }, [student]);

  useEffect(() => {
    setFilteredstates(data);
  }, [data]);

  useEffect(() => {
    if (
      typeof teacherrrr != "undefined" &&
      typeof idofclass != "undefined" &&
      typeof id != "undefined" &&
      typeof yourotp != "undefined" &&
      typeof firstname != "undefined" &&
      typeof lastname != "undefined" &&
      typeof phonenumber != "undefined"
    ) {
      let number = Date.now();
      updateDoc(doc(firebase, "users", teacherrrr), {
        studentneedingtoconfirmemail: id,
        lastphonenumbercheck: number,
        otpsent: yourotp,
        firstnamesentt: firstname,
        lastnamesent: lastname,
        phonenumbersent: phonenumber,
      }).catch((error) => {
        console.log(error);
        alert(error);
      });
    }
  }, [teacherrrr, idofclass, yourotp, firstname, lastname, phonenumber, id]);

  const textsearchedstates = () => {
    setSearchingstate(true);

    console.log("an array of states1");
    let postss = [];
    for (let i in data) {
      let match = false;
      let postt = data[i];

      for (let prop in postt) {
        let lower = JSON.stringify(postt[prop]).toLowerCase();
        if (lower.includes(student.toString().toLowerCase(), 1)) {
          match = true;
        }
      }
      if (match === true) {
        if (!postss.includes(postt.id)) {
          postss.push(postt);
        }
      }
    }
    setFilteredstates(postss);
  };

  // Navigation handling for web
  const handleNavigate = (screenName, params) => {
    // In a real app, we'd use React Router or another navigation solution
    console.log(`Navigating to ${screenName} with params:`, params);
    // For now just alert the user
    alert(`Would navigate to ${screenName}`);
  };

  async function getcoursesenrolledin() {
    if (typeof id != "undefined") {
      const q = query(
        collection(firebase, "classesbeingtaught"),
        where("students", "array-contains", id)
      );

      const querySnapshot = await getDocs(q).then(function (snapshot) {
        const array = [];
        snapshot.forEach((doc) => {
          array.push(doc.data().id);
        });
        setCoursesenrolled(array);
      });

      const snapshot1 = await getCountFromServer(q);
      const totalCount = snapshot1.data().count;
      console.log("courses enrolled in", totalCount);
    }
  }

  useEffect(() => {
    if (typeof data != "undefined") {
      // Check for classid3 from both route params and location state
      const classId = classid3 || location.state?.classid3;

      if (classId) {
        console.log("Setting selected class using classId:", classId);
        setTimeout(() => {
          setNum(data.findIndex((object) => object.id === classId));
        }, 1000);

        const foundClass = data.find((obj) => obj.id === classId);
        if (foundClass) {
          setSelectedclass(foundClass);
        }
      }
    }
  }, [data, classid3, location.state]);

  // Render the UI
  return (

      <div className="App22">
          <NavBar
            donotshow={donotshow}
            role={role}
            selectedclass={selectedclass}
            setSelectedclass={setSelectedclass}
            temparray={temparray}
            activeid={activeid}
            id={id}
            userState={userState}
            setUserState={setUserState}
            currentpage={"AvailableClasses"}
            personaldata={personaldata}
            id2={id2}
          />
    <div className="container2">
      {language2 != "English" && tempeng != true ? (
        // Non-English UI
        <>
          {typeof classid != "undefined" &&
          verifyphone == "verifyphone" &&
          pnumber.length != 10 ? (
            <div>
              <div className="topcontainer29">
                <div className="view29">
                  <p className="paragraph29">{text15}</p>
                </div>
              </div>

              <div className="bottomcontainer29">
                {editmyphonenumber == true ? (
                  <input
                    className="Newrow"
                    placeholder="Your Phone Number"
                    type="number"
                    value={phonenumberbefore}
                    onChange={(e) => onChanged(e.target.value)}
                    maxLength={10}
                  />
                ) : (
                  <input
                    className="Newrow"
                    placeholder={text9}
                    value={otpfromtext}
                    onChange={(e) => setOtpfromtext(e.target.value)}
                    maxLength={4}
                  />
                )}
              </div>

              <div className="section329">
                <div className="scroll-container">
                  {editmyphonenumber != true ? (
                    <p
                      className="paragraph2"
                      onClick={() => setEditphonenumber(true)}
                    >
                      {text12}
                    </p>
                  ) : editmyphonenumber == true &&
                    phonenumberbefore.length == 10 ? (
                    <p
                      className="paragraph22"
                      onClick={() => savethisphonenumber()}
                    >
                      {text13}
                    </p>
                  ) : editmyphonenumber == false ? (
                    <p className="paragraph2">{text14}</p>
                  ) : (
                    <p
                      className="paragraph2"
                      onClick={() => setEditphonenumber(true)}
                    >
                      {text12}
                    </p>
                  )}
                  <p className="paragraph2 spacer">
                    {text3} <br />
                    {text4}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="topcontainer">
                <p className="paragraph6">{text0}:</p>
                {typeof firstname != "undefined" &&
                typeof lastname != "undefined" ? (
                  <p className="paragraph5">
                    {firstname} {lastname}
                  </p>
                ) : (
                  <p className="paragraph5">{text1}</p>
                )}
                {editmyphonenumber == true ? (
                  <p className="paragraph">{text16}</p>
                ) : idofclass ? (
                  <p className="paragraph">{text8}</p>
                ) : (
                  <p className="paragraph">{text2}</p>
                )}
              </div>

              <div
                className={
                  typeof idofclass != "undefined"
                    ? "bottomcontainer"
                    : "bottomcontainerAA"
                }
              >
                {editmyphonenumber == true ? (
                  <input
                    className="Newrow"
                    placeholder={text18}
                    type="number"
                    value={phonenumberbefore}
                    onChange={(e) => onChanged(e.target.value)}
                    maxLength={10}
                  />
                ) : idofclass ? (
                  <input
                    className="Newrow"
                    placeholder={text9}
                    value={otpfromtext}
                    onChange={(e) => setOtpfromtext(e.target.value)}
                    maxLength={4}
                  />
                ) : (
                  <input
                    className="Newrow"
                    placeholder={text7}
                    value={student}
                    onChange={(e) => setStudent(e.target.value)}
                  />
                )}

                <RadioButton
                  classid={classid}
                  data={filteredstates}
                  idofclass={idofclass}
                  setIsselected={setIsselected}
                  language2={language2}
                  languagecode2={languagecode2}
                  tempeng={tempeng}
                  setTempeng={setTempeng}
                  setShowspinner={setShowspinner}
                  showspinner={showspinner}
                  setSelectedclass={setSelectedclass}
                  selectedclass={selectedclass}
                  pickindex={pickindex}
                  setPickindex={setPickindex}
                  num={num}
                  setNum={setNum}
                />
              </div>

              <div className="section3">
                <div className="scroll-container">
                  {yourotp == otpfromtext ? (
                    <p
                      className="paragraph2"
                      onClick={() => enrollingstudent()}
                    >
                      {text10}
                      <br />
                      {text11}
                    </p>
                  ) : (
                    <>
                      {editmyphonenumber != true ? (
                        <p
                          className="paragraph2"
                          onClick={() => setEditphonenumber(true)}
                        >
                          {text12}
                        </p>
                      ) : editmyphonenumber == true &&
                        phonenumberbefore.length == 10 ? (
                        <p
                          className="paragraph22"
                          onClick={() => savethisphonenumber()}
                        >
                          {text13}
                        </p>
                      ) : editmyphonenumber == false ? (
                        <p className="paragraph2">{text14}</p>
                      ) : (
                        <p
                          className="paragraph2"
                          onClick={() => setEditphonenumber(true)}
                        >
                          {text12}
                        </p>
                      )}
                      <p className="paragraph2 spacer">
                        {text3} <br />
                        {text4}
                      </p>
                    </>
                  )}

                  {showspinner && <div className="spinner"></div>}

                  <p className="paragraph2 divider">___________________</p>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        // English UI
        <>
          {typeof classid != "undefined" &&
          verifyphone == "verifyphone" &&
          pnumber.length != 10 ? (
            <div>
              <div className="topcontainer29">
                <div className="view29">
                  <p className="paragraph29">
                    Your Phone Number is unverified.<br />Input the Correct One
                    Below
                  </p>
                </div>
              </div>

              <div className="bottomcontainer29">
                {editmyphonenumber == true ? (
                  <input
                    className="Newrow"
                    placeholder="Your Phone Number"
                    type="number"
                    value={phonenumberbefore}
                    onChange={(e) => onChanged(e.target.value)}
                    maxLength={10}
                  />
                ) : (
                  <input
                    className="Newrow123"
                    placeholder="Enter 'OTP' from Text"
                    value={otpfromtext}
                    onChange={(e) => setOtpfromtext(e.target.value)}
                    maxLength={4}
                  />
                )}
              </div>

              <div className="section329">
                <div className="scroll-container">
                  {editmyphonenumber != true ? (
                    <p
                      className="paragraph2"
                      onClick={() => setEditphonenumber(true)}
                    >
                      Edit My Phone Number
                    </p>
                  ) : editmyphonenumber == true &&
                    phonenumberbefore.length == 10 ? (
                    <p
                      className="paragraph22"
                      onClick={() => savethisphonenumber()}
                    >
                      Save This Number
                    </p>
                  ) : editmyphonenumber == false ? (
                    <p className="paragraph2">
                      You are now awaiting an 'OTP' from your teacher
                    </p>
                  ) : (
                    <p
                      className="paragraph2"
                      onClick={() => setEditphonenumber(true)}
                    >
                      Edit My Phone Number
                    </p>
                  )}
                  <p className="paragraph2 spacer">
                    'OTP' can be sent by the teacher from <br />'Passes From
                    This Class' screen OR <br />'Students Enrolled' screen.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="topcontainer">
                <p className="paragraph6">Current User:</p>
                {typeof firstname != "undefined" &&
                typeof lastname != "undefined" ? (
                  <p className="paragraph5">
                    {firstname} {lastname}
                  </p>
                ) : (
                  <p className="paragraph5">Guest</p>
                )}

                {editmyphonenumber == true ? (
                  <p className="paragraph">Phone Number Edit</p>
                ) : idofclass ? (
                  <p className="paragraph">
                    Request "OTP" Text from Teacher
                  </p>
                ) : (
                  <p className="paragraph">
                    Find & Select Your Current Class
                  </p>
                )}
              </div>

              <div
                className={
                  typeof idofclass != "undefined"
                    ? "bottomcontainer"
                    : "bottomcontainerAA"
                }
              >
                {editmyphonenumber == true ? (
                  <input
                    className="Newrow"
                    placeholder="Your Phone Number"
                    type="number"
                    value={phonenumberbefore}
                    onChange={(e) => onChanged(e.target.value)}
                    maxLength={10}
                  />
                ) : idofclass ? (
                  <input
                    className="Newrow123"
                    placeholder="Enter 'OTP' from Text"
                    value={otpfromtext}
                    onChange={(e) => setOtpfromtext(e.target.value)}
                    maxLength={4}
                  />
                ) : (
                  <input
                    className="Newrow123"
                    placeholder="Class Identifier"
                    value={student}
                    onChange={(e) => setStudent(e.target.value)}
                  />
                )}

                <RadioButton
                  classid={classid}
                  data={filteredstates}
                  idofclass={idofclass}
                  setIsselected={setIsselected}
                  language2={language2}
                  languagecode2={languagecode2}
                  tempeng={tempeng}
                  setTempeng={setTempeng}
                  setShowspinner={setShowspinner}
                  showspinner={showspinner}
                  setSelectedclass={setSelectedclass}
                  selectedclass={selectedclass}
                  pickindex={pickindex}
                  setPickindex={setPickindex}
                  num={num}
                  setNum={setNum}
                />
              </div>

              <div className="section3">
                <div className="scroll-container">
                  {yourotp == otpfromtext ? (
                    <p className="paragraph2">
                      That is the correct code! <br />Press Here to Enter Class.
                    </p>
                  ) : (
                    <>
                      {editmyphonenumber != true ? (
                        <p
                          className="paragraph2"
                          onClick={() => setEditphonenumber(true)}
                        >
                          Edit My Phone Number
                        </p>
                      ) : editmyphonenumber == true &&
                        phonenumberbefore.length == 10 ? (
                        <p
                          className="paragraph22"
                          onClick={() => savethisphonenumber()}
                        >
                          Save This Number
                        </p>
                      ) : editmyphonenumber == false ? (
                        <p className="paragraph2">
                          You are now awaiting an 'OTP' from your teacher
                        </p>
                      ) : (
                        <p
                          className="paragraph2"
                          onClick={() => setEditphonenumber(true)}
                        >
                          Edit My Phone Number...
                        </p>
                      )}
                      <p className="paragraph2 spacer">
                        'OTP' can be sent by the teacher from <br /> 'Admit
                        Students' screen.
                      </p>
                    </>
                  )}
                  <p className="paragraph2 divider">___________________</p>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
     </div>
  );
};

export default Availableclassesatyourschool;